import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';
import { MenuService } from '../menu/menu.service';
import { AsistenteFormularioService } from './asistente-formulario.service';
import { Asistente } from 'src/app/asistente-en-linea/models/Asistente';
import { AuthService } from '../../auth/auth.service';
import { AreaFuncionalGAFU } from '../../models/area-funcional-gafu';
import { Destinatario } from 'src/app/asistente-en-linea/models/Destinatario';
import { DestinatariosService } from '../destinatarios/destinatarios.service';
import { AsistenteTipo } from "src/app/config/config/models/asistente-tipo";

@Component({
  selector: 'app-asistente-formulario',
  templateUrl: './asistente-formulario.component.html',
  styleUrls: ['./asistente-formulario.component.scss']
})
export class AsistenteFormularioComponent implements OnInit {
  codigo: string = '';
  nombre: string = '';
  areaFuncional: string = '';
  tipoFormulario: string = 'Persona';
  tema: string = '';
  destinatario: number;
  habilitado: boolean = false;
  requiereAutenticacion: boolean = false;
  EsEdicion: boolean = false;
  IdAsistente: number;
  loading: boolean = false;
  error: string = '';
  errorValidacionCreacion: boolean = false;
  areasFuncionalesGAFU: AreaFuncionalGAFU[];
  areaFuncionalSeleccionada: AreaFuncionalGAFU;
  gafuAreaFuncional: string;
  esUsuarioAdminitrador: boolean = false;
  destinatarios: Destinatario[] = [];

  constructor(
    private readonly menuService: MenuService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly asistenteFormularioService: AsistenteFormularioService,
    private readonly authService: AuthService,
    private readonly destinatariosService: DestinatariosService
  ) { }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params: any) => {
      if (params.params.idAsistente) {
        this.EsEdicion = true;
        this.IdAsistente = params.params.idAsistente;
        this.loadAsistente(this.IdAsistente);
      }
    })

    this.areasFuncionalesGAFU = [];

    this.esUsuarioAdminitrador = this.authService.esAdministrador();

    if (!this.esUsuarioAdminitrador) {
      this.areasFuncionalesGAFU.push(new AreaFuncionalGAFU("Acceso a todas las areas funcionales", "*", "Todos"));
      for (let area of this.authService.getUser().areasFuncionales) {
        this.areasFuncionalesGAFU.push(area);
      }
      console.log(this.areasFuncionalesGAFU)
    }

    this.myOptionsAreasFunciones = this.areasFuncionalesGAFU.map((a: AreaFuncionalGAFU) => ({ label: a.descripcion, value: a.areaFuncional }));

    this.loadDestinatarios();
  }

  myOptions = [
    { label: 'Persona', value: 'Persona' },
    { label: 'Empresa', value: 'Empresa' },
  ];

  myOptionsDestinatario: { label: string; value: number }[] = [];

  myOptionsAreasFunciones: { label: string; value: string }[] = [];

  loadAsistente(id) {
    this.loading = true;
    this.asistenteFormularioService.get(id).subscribe((data: any) => {
      this.loading = false;
      if (data && (data.statusCode == 200 || data.statusCode == 0)) {
        let asistente = data.content as Asistente;
        this.codigo = asistente.codigoAsistente;
        this.nombre = asistente.descripcion;
        this.areaFuncional = asistente.gafuAreaFuncional;
        this.tipoFormulario = asistente.formulario.tipoFormulario;
        this.tema = asistente.formulario.tema;
        this.destinatario = asistente.formulario.idDestinatario;
        this.habilitado = asistente.habilitado;
        this.requiereAutenticacion = asistente.requiereAutenticacion;
      }
      else {
        alert(data.statusMessage);
      }
    },
      error => {
        alert(error);
        this.loading = false;
      })
  }

  salirAdministrador() {
    this.menuService.salirAdministrador();
    this.router.navigate(["/login"]);
  }

  onSelected(selectedValue) {
    this.tipoFormulario = selectedValue;
  }

  onSelectedDestinatario(selectedValue) {
    this.destinatario = selectedValue;
  }

  onSubmit() {
    this.applyOperation();
  }

  volver() {
    this.router.navigate(['/config/home']);
  }

  async applyOperation() {
    this.error = '';
    let resArray = [];
    this.errorValidacionCreacion = false;
    if (this.isDataValid()) {
      this.loading = true;
      let idDest;
      let idDestFin = 0;

      if (this.EsEdicion) {
        resArray.push(await this.asistenteFormularioService.update(this.IdAsistente, this.codigo, this.nombre, this.nombre, this.areaFuncional, this.habilitado, this.requiereAutenticacion, this.tipoFormulario,
          this.tema, this.destinatario).toPromise().catch((err) => {
            this.loading = false;
            this.error = err.message;
          }));
      } else {
        resArray.push(await this.asistenteFormularioService.add(this.codigo, this.nombre, this.nombre, this.areaFuncional, this.tipoFormulario, this.tema, this.destinatario, this.requiereAutenticacion)
          .toPromise().catch((err) => {
            this.loading = false;
            this.error = err.message;
          }));

      }

      let noErr = resArray.reduce((previous, current) => {
        idDest = current.id;
        return previous && (current.statusCode == 200 || current.statusCode == 0 ? true : false);
      }, true)
      if (idDest) {
        idDestFin = Number(idDest);
      }
      if (noErr) {
        if (idDestFin < 0) {
          if (idDest === '-1') {
            this.error = "Atención: Ya existe otro menú con el mismo identificador";
          } else if (idDest === '-2') {
            this.error = "Atención: Ya existe otro menú con el mismo nombre";
          } else {
            this.error = "Atención: Ya existe otro menú con el mismo identificador y nombre";
          }
          this.errorValidacionCreacion = true;
        } else {
          this.irPaginaInicio();
        }
        this.loading = false;
      } else {
        this.loading = false;
        alert("Ocurrió un error, intente nuevamente más tade");
      }
    } else {
      this.errorValidacionCreacion = true;
    }

  }

  isDataValid() {
    this.error = "";
    //debugger
    // if (this.codigo && this.nombre && this.texto && this.gafuAreaFuncional) {
    if (this.codigo && this.nombre && this.areaFuncional) {
      if (this.codigo.length > 25) {
        this.error = "Atención: El código del asistente no puede superar los 25 caracteres";
        return false;
      } else {
        if (/\s/.test(this.codigo)) {
          this.error = "Atención: El código no puede contener espacios en blanco";
          return false;
        } else {
          let isValid = /[a-zA-Z0-9-_]/.test(this.codigo);
          if (!isValid) {
            this.error = "Atención: El código no puede contener caracteres especiales. Solo se admiten números, letras y los caracteres - y _";
            return false;
          }
        }
      }

      if (this.nombre.length > 60) {
        this.error = "Atención: El nombre del menú no puede superar los 60 caracteres";
        return false;
      }
      // if (this.texto.length > 250) {
      //   this.error = "Atención: La descripción del menú no puede superar los 250 caracteres";
      //   return false;
      // }
      if (this.areaFuncional.length > 20) {
        this.error = "Atención: El código de área funcional del menú no puede superar los 20 caracteres";
        return false;
      }
      return true;
    } else {
      this.error = "Por favor, asegúrese de ingresar todos los campos obligatorios";
      return false;
    }
  }

  irPaginaInicio() {
    this.router.navigate(['/config/home/']);
  }


  loadDestinatarios() {
    this.destinatarios = [];
    this.destinatariosService.loadDestinatariosMenu(false).subscribe((data: any) => {
      if (data && (data.statusCode == 200 || data.statusCode == 0)) {
        if (data.content.length > 0) {
          for (let m of data.content) {
            let destinatario = new Destinatario(
              m.id,
              m.codigo,
              m.descripcion,
              m.titulo,
              m.targetType,
              m.target,
              this.getFormattedDate(new Date(m.fechaCreacion)),
              this.getFormattedDate(new Date(m.fechaActualizacion)),
              m.usuarioAutualizador,
              m.habilitado
            );

            if (destinatario.targetType == "EMAIL" && destinatario.habilitado) {
              this.destinatarios.push(destinatario);
            }
          }

          console.log(this.destinatarios)
          this.myOptionsDestinatario = this.destinatarios.map((a: Destinatario) => ({ label: a.titulo + " - " + a.target, value: a.id }));

        }
      }
      else {
        alert(data.statusMessage);
      }
    },
      error => {
        alert(error);
      })
  }

  getFormattedDate(date) {
    let year = date.getFullYear();
    let month = (1 + date.getMonth()).toString().padStart(2, '0');
    let day = date.getDate().toString().padStart(2, '0');

    let hour = date.getHours().toString().padStart(2, '0');
    let minutes = date.getMinutes().toString().padStart(2, '0');
    let seconds = date.getSeconds().toString().padStart(2, '0');
    return day + '/' + month + '/' + year + " " + hour + ":" + minutes + ":" + seconds;
  }
}
